import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'insuranceCardDetailsMixin',

  data() {
    return {
      insuranceFields: [],
    };
  },

  computed: {
    ...mapGetters({
      userFirstName: 'global/userFirstName',
      getBrandUnitIdVariables: 'getBrandUnitIdVariables',
    }),

    ...mapState({
      payment: (state) => state.currentAdmission.data.payments[0],
      insuranceVariables: (state) => state.healthInsurance.data.healthInsuranceVariables,
      admissionOrigin: ({ currentAdmission }) => currentAdmission.data.source.origin,
    }),

    cardDetails() {
      return {
        insuranceName: this.insuranceVariables.nomeCliente,
        clientName: this.userFirstName,
        cardExpirationDate: this.cardExpirationDate,
        cardNumber: this.payment.details.cardNumber,
        insuranceFields: this.insuranceFields,
      };
    },

    clientId() {
      return parseInt(this.payment.clientId);
    },

    routerLinkParams() {
      return {
        name: 'change-insurance',
        params: {
          path: 'cliente',
          header: {
            hidePreviousBtn: false,
            title: 'Escolha seu convênio',
          },
        },
      };
    },

    cardExpirationDate() {
      const cardExpirationDate = this.payment.details?.cardExpirationDate;

      if (!cardExpirationDate) {
        return '';
      }

      const formatedDate = cardExpirationDate.split('T')[0];
      return this.$moment(formatedDate).format('DD/MM/YYYY');
    }
  },

  methods: {
    ...mapActions([
      'healthInsuranceVariablesSelector'
    ]),

    async getInsuranceVariables() {
      const params = {
        clientId: this.clientId,
        brandId: this.getBrandUnitIdVariables.brandId,
        negotiationVariables: this.payment.details.negotiationVariables,
        admissionOrigin: this.admissionOrigin,
      };

      if (params.negotiationVariables) {
        await this.healthInsuranceVariablesSelector(params);

        if (!this.insuranceVariables) {
          this.insuranceHasErrors = true;
          return false;
        }

        this.getInsuranceCardFields();
      }
    },

    async getInsuranceCardFields() {
      const healthInsuranceVariables = this.insuranceVariables.variaveis;
      healthInsuranceVariables.forEach(item => {
        const newField = this.addNewCardField(item);

        if (newField) {
          this.insuranceFields.push(newField);
        }
      });
    },

    addNewCardField(item) {
      if (!item.valores) {
        this.insuranceHasErrors = true;
        return false;
      }

      return {
        question: {
          id: item.id,
          content: item.nome,
        },
        answer: {
          id: item.valores[0].id,
          content: item.valores[0].valor,
        }
      };
    }
  },
};
